import React, { useState } from "react";
import Button from '../../general/Button/Button'; // Verifique o componente Button
import CardAdmin from '../CardAdmin/CardAdmin'; // Importa o CardAdmin
import "./TopicManager.css";

const TopicManager = ({ users, groups, dashs, onDelete, handleChangeType, changeType }) => {

  return (
    <div className="topic-manager">
      <div className="buttons-manager">
        <Button
          variant="primary"
          className={`btn-topic-manager ${changeType === "gerenciarUsuarios" ? "active" : ""}`}
          fullWidth
          onClick={() => handleChangeType("gerenciarUsuarios")}
        >
          Usuários
        </Button>
        <Button
          variant="primary"
          className={`btn-topic-manager ${changeType === "gerenciarDashboard" ? "active" : ""}`}
          fullWidth
          onClick={() => handleChangeType("gerenciarDashboard")}
        >
          Dashboards
        </Button>
        <Button
          variant="primary"
          className={`btn-topic-manager ${changeType === "gerenciarGrupos" ? "active" : ""}`}
          fullWidth
          onClick={() => handleChangeType("gerenciarGrupos")}
        >
          Grupos
        </Button>
      </div>

      <div className="conteudo-manager">
        {changeType === "gerenciarUsuarios" && (
          <div>
            <div className="card-admin-row">
              {users.map((user) => (
                <CardAdmin key={user.uid} type={"usuario"} data={user} onDelete={onDelete}/>
              ))} 
            </div>
          </div>
        )}
        {changeType === "gerenciarGrupos" && (
          <div>
            <div className="card-admin-row">
              {groups.map((grupo) => (
                <CardAdmin key={grupo.uid} type={"grupo"} data={grupo} onDelete={onDelete} />
              ))}
            </div>
          </div>
        )}
        {changeType === "gerenciarDashboard" && (
          <div>
            <div className="card-admin-row">
              {dashs.map((dashboard) => (
                <CardAdmin key={dashboard.id} type={"dashboard"} data={dashboard} onDelete={onDelete} />
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopicManager;
